import { getCurrentUser } from 'aws-amplify/auth';
import { useEffect, useState } from 'react';

export const useAuthentification = () => {
  const [isAuth, setIsAuth] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const authentication = async () => {
    const auth = await isAuthenticated();
    setIsAuth(auth);
    setIsLoading(false);
  };
  useEffect(() => {
    authentication();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isAuthenticated = async () => {
    try {
      await getCurrentUser();
      return true;
    } catch {
      return false;
    }
  };

  return { isAuth, isLoading };
};
